/**
 * Maps Anova API / JWT `user_groups` numeric enum values to the string names used across the UI
 * (see Anova `Group` enum and `ROLES` in `config/constants`).
 */
const GROUP_NUMBER_TO_NAME = {
  0: 'Representative',
  1: 'ResearchSite',
  2: 'Sponsor',
  3: 'Blocked',
  4: 'Deleted',
  5: 'RepresentativeRegistration',
  6: 'ResearchSiteRegistration',
  7: 'SponsorRegistration',
  8: 'Personnel',
  9: 'PersonnelRegistration',
  10: 'InactiveResearchSite',
  11: 'InactiveSponsor',
  12: 'InactivePersonnel',
  13: 'ResearchSitePersonnel',
  14: 'SponsorPersonnel',
  15: 'OrganizationPersonnelBlocked',
  16: 'PatientAdmin',
  999: 'Administrator',
};

export function normalizeUserGroups(groups) {
  if (!Array.isArray(groups)) {
    return groups;
  }

  return groups.map((g) => {
    if (typeof g === 'number' && GROUP_NUMBER_TO_NAME[g] != null) {
      return GROUP_NUMBER_TO_NAME[g];
    }
    if (typeof g === 'string' && /^\d+$/.test(g)) {
      const n = Number(g);
      if (GROUP_NUMBER_TO_NAME[n] != null) {
        return GROUP_NUMBER_TO_NAME[n];
      }
    }
    return g;
  });
}
